import { render, staticRenderFns } from "./generalInformation.vue?vue&type=template&id=68cf6a73&"
import script from "./generalInformation.vue?vue&type=script&lang=js&"
export * from "./generalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports